import * as styles from './TogglePanel.module.less';
import { PropsWithChildren, useState } from 'react';
import { Icon, Icons } from './Buttons';

export interface ITogglePanelProps {
    title: string;
    initial?: boolean;
}

export const TogglePanel = ({title, initial, children}: PropsWithChildren<ITogglePanelProps>) => {
    const [showing, setShowing] = useState(!!initial);
    return (
        <div className={styles.panel}>
            <div className={styles.panelHeader} onClick={() => setShowing(!showing)}>
                <div>{title}</div>
                <Icon icon={showing ? Icons.ChevronUp : Icons.ChevronDown}/>
            </div>
            {
                showing && (
                    <div className={styles.panelBody}>
                        {children}
                    </div>
                )
            }
        </div>
    )
}